import React , {useEffect} from "react";
import OptionBarServiceButton from "../OptionBarServiceButton";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
} from "react-router-dom";
// TODO: in the optionbar service button , remember to change forms to also incloud outbund and inbound forms
import AgentOptionBarServiceButtonWithForms from "../Agent/AgentOptionBarServiceButtonWithForms";
import RenderAgentFormList from "./RenderAgentFormList";
const RenderAgentNestedServices = (props) => {
  const { service , options, isOpen, forms, children  , icon , customPath} = props;
  useEffect(() => {
    console.log( forms)
  }, []);
  return (
    <ul className={isOpen ? "list-is-open" : "list-is-closed"} >
      {
        options && options.map((option) => 
         <AgentOptionBarServiceButtonWithForms option = { option } icon = {icon} forms = {option.offlineForms} customPath = {customPath}/>
        )
      }
      {forms && forms.length > 0 && <RenderAgentFormList service = {service } forms = {forms} customPath = {customPath} />}
      
    </ul>
  );
};

export default RenderAgentNestedServices;
